// src/pages/RelatorioNovo.js

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AdminLayout from "../components/AdminLayout";

function AgendasNovo() {
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [formData, setFormData] = useState({
    sigedNR: "",
    nomeOSC: "",
    cnpj: "",
    endereco: "",
    responsavelEntidade: "",
    telefone: "",
    email: "",
    tituloProjeto: "",
    numeroBeneficiarios: "",
    valor: "",
    objetivoGeral: "",
    objetivosEspecificos: "",
    cronogramaExecucao: "",
    indicadoresMonitoramento: "",
    nomeGestor: "",
    cargoGestor: "",
    matriculaGestor: "",
    portaria: "",
    edicao: "",
    pagina: "",
    termoFomento: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [gestores, setGestores] = useState([]); // Para armazenar a lista de gestores

  useEffect(() => {
    // Busca os gestores do backend
    fetch(`${API_BASE_URL}gestor/`)
      .then((response) => response.json())
      .then((data) => setGestores(data))
      .catch((error) => console.error("Erro ao carregar gestores:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "gestor_id") {
        // Encontre o gestor selecionado na lista de gestores
        const selectedGestor = gestores.find((gestor) => gestor.id === parseInt(value));
        if (selectedGestor) {
            setFormData({
                ...formData,
                gestor_id: value,
                cargoGestor: selectedGestor.cargo_gestor, // Preenche o cargo do gestor
                matriculaGestor: selectedGestor.matricula_gestor, // Preenche a matrícula do gestor
            });
        }
    } else {
        let formattedValue = value;

        if (name === "email") {
            setEmailError(validateEmail(value) ? "" : "Email inválido");
        }

        if (name === "cnpj") {
            formattedValue = formatCNPJ(value);
        } else if (name === "telefone") {
            formattedValue = formatTelefone(value);
        } else if (name === "valor") {
            formattedValue = formatCurrency(value);
        }

        setFormData({
            ...formData,
            [name]: formattedValue,
        });
    }
};

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const formatCNPJ = (value) => {
    value = value.replace(/\D/g, "");
    return value
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 18);
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

  const formatCurrency = (value) => {
    value = value.replace(/\D/g, "");
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);  // Define como enviando

    // Remova a formatação do valor antes do envio
  const formDataToSend = {
    ...formData,
    valor: formData.valor.replace(/[^\d]/g, ""),  // Remove tudo exceto números
  };

    try {
        const response = await fetch(`${API_BASE_URL}instituicoes/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formDataToSend),
        });

        if (response.ok) {
            setSuccessMessage("Relatório cadastrado com sucesso!");
            setFormData({  // Limpa os campos do formulário
              sigedNR: "",
              nomeOSC: "",
              cnpj: "",
              endereco: "",
              responsavelEntidade: "",
              telefone: "",
              email: "",
              tituloProjeto: "",
              numeroBeneficiarios: "",
              valor: "",
              objetivoGeral: "",
              objetivosEspecificos: "",
              cronogramaExecucao: "",
              indicadoresMonitoramento: "",
              nomeGestor: "",
              cargoGestor: "",
              matriculaGestor: "",
              portaria: "",
              edicao: "",
              pagina: "",
              termoFomento: "",
              cpfResponsavelOSC: "",
              rgResponsavelOSC: "",
              orgaoResponsavelOSC: "",
              cargoResponsavelOSC: "",
              bairroResponsavelOSC: "",
              ruaResponsavelOSC: "",
              numeroResponsavelOSC: "",
              cepResponsavelOSC: "",
              nomeResponsavelTecnico: "",
              profissaoResponsavelTecnico: "",
              numeroConselhoResponsavelTecnico: "",
              telefoneResponsavelTecnico: "",
              emailResponsavelTecnico: "",
            });
            
            setTimeout(() => {
                setSuccessMessage("");  // Oculta a mensagem de sucesso após alguns segundos
                navigate("/agendas");  // Redireciona para a página de monitoramento
            }, 3000);  // Ajuste o tempo para controlar o intervalo de exibição da mensagem
        } else {
          setErrorMessage("Falha ao cadastrar agenda.");
      }
        } catch (error) {
            setErrorMessage("Ocorreu um erro ao enviar o formulário.");
        } finally {
            setIsSubmitting(false);  // Libera o formulário após o término
        }
    };

  useEffect(() => {
    if (successMessage || errorMessage) {
        const timer = setTimeout(() => {
            setSuccessMessage("");
            setErrorMessage("");
        }, 5000); // 5 segundos
        return () => clearTimeout(timer);
    }
}, [successMessage, errorMessage]);

  return (
    <AdminLayout>
      <div>
          {successMessage && (
              <div className="alert alert-success alert-float">
                  {successMessage}
              </div>
          )}
          {errorMessage && (
              <div className="alert alert-danger alert-float">
                  {errorMessage}
              </div>
          )}
      </div>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit} disabled={isSubmitting}>
            <div className="card-body">
              <h3 className="card-title">Cadastro de Agenda</h3>
              <div className="row row-cards">
                {/* Identificação */}
                <h4 className="mt-4">1. Identificação</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nº do Processo SIGED</label>
                    <input type="text" className="form-control" name="sigedNR" onChange={handleChange} value={formData.sigedNR} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome da OSC</label>
                    <input type="text" className="form-control" name="nomeOSC" onChange={handleChange} value={formData.nomeOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">CNPJ</label>
                    <input
                      type="text"
                      className="form-control"
                      name="cnpj"
                      onChange={handleChange}
                      value={formData.cnpj}
                    />
                  </div>
                </div>

                {/* Endereço e Responsável pela Entidade */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Bairro</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Rua</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nº</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">CEP</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Ponto de Referência</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                {/* Telefone e Email */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefone"
                      onChange={handleChange}
                      value={formData.telefone}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      onChange={handleChange}
                      value={formData.email}
                    />
                    {emailError && (
                      <small className="text-danger">{emailError}</small>
                    )}
                  </div>
                </div>

                 {/* Identificação */}
                 <h4 className="mt-4">1.1 Informações do Responsável pela OSC</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input type="text" className="form-control" name="responsavelEntidade" onChange={handleChange} value={formData.responsavelEntidade} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">CPF</label>
                    <input type="text" className="form-control" name="cpfResponsavelOSC" onChange={handleChange} value={formData.cpfResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">RG</label>
                    <input type="text" className="form-control" name="rgResponsavelOSC" onChange={handleChange} value={formData.rgResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Orgão Expedidor</label>
                    <input type="text" className="form-control" name="orgaoResponsavelOSC" onChange={handleChange} value={formData.orgaoResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Cargo</label>
                    <input type="text" className="form-control" name="cargoResponsavelOSC" onChange={handleChange} value={formData.cargoResponsavelOSC} />
                  </div>
                </div>
                <h4 className="mt-4">1.2 Endereço do Responsável pela OSC</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Bairro</label>
                    <input type="text" className="form-control" name="bairroResponsavelOSC" onChange={handleChange} value={formData.bairroResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Rua</label>
                    <input type="text" className="form-control" name="ruaResponsavelOSC" onChange={handleChange} value={formData.ruaResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nº</label>
                    <input type="text" className="form-control" name="numeroResponsavelOSC" onChange={handleChange} value={formData.numeroResponsavelOSC} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">CEP</label>
                    <input type="text" className="form-control" name="cepResponsavelOSC" onChange={handleChange} value={formData.cepResponsavelOSC} />
                  </div>
                </div>

                {/* Dados do Projeto */}
                <h4 className="mt-4">2. Dados do Projeto</h4>
                <h4 className="mt-4">2.1 Responsável Técnico pelo Projeto</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nome</label>
                    <input type="text" className="form-control" name="nomeResponsavelTecnico" onChange={handleChange} value={formData.nomeResponsavelTecnico} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Profissão</label>
                    <input type="text" className="form-control" name="profissaoResponsavelTecnico" onChange={handleChange} value={formData.profissaoResponsavelTecnico} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Nº de Inscrição no Conselho</label>
                    <input type="text" className="form-control" name="numeroConselhoResponsavelTecnico" onChange={handleChange} value={formData.numeroConselhoResponsavelTecnico} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input type="text" className="form-control" name="telefoneResponsavelTecnico" onChange={handleChange} value={formData.telefoneResponsavelTecnico} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">E-mail</label>
                    <input type="text" className="form-control" name="emailResponsavelTecnico" onChange={handleChange} value={formData.emailResponsavelTecnico} />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Título do Projeto</label>
                    <input type="text" className="form-control" name="tituloProjeto" onChange={handleChange} value={formData.tituloProjeto} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Número de Beneficiários</label>
                    <input type="text" className="form-control" name="numeroBeneficiarios" onChange={handleChange} value={formData.numeroBeneficiarios} />
                  </div>
                </div>

                {/* Valor, Objetivo Geral e Específicos */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Valor</label>
                    <input
                      type="text"
                      className="form-control"
                      name="valor"
                      onChange={handleChange}
                      value={formData.valor}
                    />
                  </div>
                </div>
                <h4 className="mt-4">3. Objetivos do Projeto</h4>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Objetivo Geral</label>
                    <textarea className="form-control" name="objetivoGeral" rows="3" onChange={handleChange} value={formData.objetivoGeral}></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Objetivos Específicos</label>
                    <textarea className="form-control" name="objetivosEspecificos" rows="3" onChange={handleChange} value={formData.objetivosEspecificos}></textarea>
                  </div>
                </div>

                {/* Cronograma e Indicadores */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Cronograma de Execução</label>
                    <textarea className="form-control" name="cronogramaExecucao" rows="3" onChange={handleChange} value={formData.cronogramaExecucao}></textarea>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Indicadores de Monitoramento de Metas</label>
                    <textarea className="form-control" name="indicadoresMonitoramento" rows="3" onChange={handleChange} value={formData.indicadoresMonitoramento}></textarea>
                  </div>
                </div>

                {/* Identificação do Gestor */}
                <h4 className="mt-4">4. Identificação do Gestor</h4>
                {/* Campo para selecionar o Gestor */}
                <div className="col-md-6">
                  <div className="mb-3">
                      <label className="form-label">Gestor</label>
                      <select
                          className="form-select"
                          name="gestor_id"
                          value={formData.gestor_id || ""} // Garantir valor vazio como padrão
                          onChange={handleChange}
                          required
                      >
                          <option value="" disabled>
                              Selecione um gestor
                          </option>
                          {gestores.map((gestor) => (
                              <option key={gestor.id} value={gestor.id}>
                                  {gestor.nome_gestor}
                              </option>
                          ))}
                      </select>
                  </div>
              </div>
              </div>
            </div>
            <div className="card-footer text-end">
            <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={() =>
                    setFormData({
                      sigedNR: "",
                      nomeOSC: "",
                      cnpj: "",
                      endereco: "",
                      responsavelEntidade: "",
                      telefone: "",
                      email: "",
                      tituloProjeto: "",
                      numeroBeneficiarios: "",
                      valor: "",
                      objetivoGeral: "",
                      objetivosEspecificos: "",
                      cronogramaExecucao: "",
                      indicadoresMonitoramento: "",
                      gestor_id: "",
                      cargoGestor: "",
                      matriculaGestor: "",
                      portaria: "",
                      edicao: "",
                      pagina: "",
                      termoFomento: "",
                      cpfResponsavelOSC: "",
                      rgResponsavelOSC: "",
                      orgaoResponsavelOSC: "",
                      cargoResponsavelOSC: "",
                      bairroResponsavelOSC: "",
                      ruaResponsavelOSC: "",
                      numeroResponsavelOSC: "",
                      cepResponsavelOSC: "",
                      nomeResponsavelTecnico: "",
                      profissaoResponsavelTecnico: "",
                      numeroConselhoResponsavelTecnico: "",
                      telefoneResponsavelTecnico: "",
                      emailResponsavelTecnico: "",
                    })
                  }
                >
                  Cancelar
                </button>
              <button type="submit" disabled={isSubmitting} className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AgendasNovo;